import { Directive, EventEmitter, HostBinding, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[appFileDragDrop]'
})
export class FileDragDropDirective {
  @Output() fileDropped = new EventEmitter<FileList>();
  @HostBinding('class.file-over') isFileOver = false;

  @HostListener('dragover', ['$event'])
  onDragOver(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.isFileOver = true;
  }

  @HostListener('dragleave', ['$event'])
  onDragLeave(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.isFileOver = false;
  }

  @HostListener('drop', ['$event'])
  onDrop(evt: DragEvent): void {
    evt.preventDefault();
    evt.stopPropagation();
    this.isFileOver = false;
    if (evt.dataTransfer.files.length) {
      this.fileDropped.emit(evt.dataTransfer.files);
    }
  }
}
